import React, { useState, useEffect } from "react";
import { db } from "../firebase"; // Firebase configuration
import { collection, getDocs } from "firebase/firestore"; // To get the feedbacks for all quizzes
import { useParams } from "react-router-dom"; // To get the userId from the URL params
import { toast } from "react-toastify";

const ViewFeedbacks = () => {
    const { userId } = useParams(); // Get the userId from URL parameters
    const [feedbacks, setFeedbacks] = useState([]); // Store all feedbacks here
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchFeedbacks = async () => {
            setLoading(true);
            try {
                // Fetch all feedbacks for the given userId
                const feedbacksCollectionRef = collection(db, "users", userId, "feedback");
                const feedbacksSnapshot = await getDocs(feedbacksCollectionRef);

                // If feedbacks exist, process and set the data
                if (!feedbacksSnapshot.empty) {
                    const feedbacksData = feedbacksSnapshot.docs.map((feedbackDoc) => ({
                        quizId: feedbackDoc.id,
                        feedback: feedbackDoc.data().feedback,
                    }));
                    setFeedbacks(feedbacksData);
                } else {
                    toast.error("No feedback found for this user.");
                    setFeedbacks([]);
                }
            } catch (error) {
                toast.error("Error fetching feedbacks: " + error.message);
                setFeedbacks([]);
            } finally {
                setLoading(false);
            }
        };

        fetchFeedbacks();
    }, [userId]); // Fetch feedbacks when userId changes

    if (loading) {
        return <div>Loading...</div>;
    }

    return (
        <div className="container mt-4">
            <h2 className="text-center mb-4">All Feedbacks for User {userId}</h2>

            {/* Display all feedbacks for the user */}
            {feedbacks.length === 0 ? (
                <p className="text-center">No feedbacks available for this user.</p>
            ) : (
                <div>
                    {feedbacks.map((feedback) => (
                        <div key={feedback.quizId} className="card mb-4">
                            <div className="card-header">
                                <h5 className="mb-0">Feedback for Quiz {feedback.quizId}</h5>
                            </div>
                            <div className="card-body">
                                <p>{feedback.feedback || "No feedback available."}</p>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default ViewFeedbacks;
